import React, {useEffect, useState} from 'react';
import {TimePicker} from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import {useSelector} from 'react-redux';
import locale from 'antd/es/date-picker/locale/he_IL';
import {DB_TIME_FORMAT} from "@arboxappv4/shared/src/constants/constants";

dayjs.extend(customParseFormat);


const CustomTimePicker = (props) => {
    const {onTimeSelect, defaultTime, ...rest} = props;
    const language = useSelector(state => state.site.language);
    const globalLocation = useSelector(state => state.site.selectedLocation)
    const [selectedTime, setSelectedTime] = useState(null);

    useEffect(() => {
        if (defaultTime) {
            setSelectedTime(dayjs(defaultTime, DB_TIME_FORMAT));
        }
    }, [defaultTime]);

    const snapToMinuteStep = (time, step = 15) => {
        if (!time) return time
        const snappedMinute = Math.floor(time.minute() / step) * step
        return time.minute(snappedMinute).second(0)
    }

    const onChange = (time) => {
        const nextTime = snapToMinuteStep(time)
        setSelectedTime(nextTime);
        if (onTimeSelect) {
            onTimeSelect(nextTime ? nextTime.format(DB_TIME_FORMAT) : null);
        }
    };

    return (
        <TimePicker
            className={'custom-datepicker'}
            format={'HH:mm'}
            minuteStep={15}
            value={selectedTime}
            onChange={onChange}
            allowClear={false}
            showNow={false}
            needConfirm={false}
            placeholder={''}
            locale={language?.code === 'he' ? locale : null}
            {...rest}
        />
    );
};

export default CustomTimePicker;
